import { ConstantsOpenPose } from '../../constants_open_pose';
import { EOpenPoseBodyGroup } from '../../enums/e_open_pose_body_group';
import { EOpenPoseBodyNode as EOPBN } from '../../enums/e_open_pose_body_node';
import { create_group, create_joint } from '../open_pose_body_utils';

export function open_pose_body_create_template() {
  const width = ConstantsOpenPose.BASE_BODY_WIDTH;
  const height = ConstantsOpenPose.BASE_BODY_HEIGHT;

  const torso = create_group(EOpenPoseBodyGroup.TORSO, 0, 115, 0).add(
    create_joint(EOPBN.NECK, 0, height / 2, 0).add(
      create_joint(EOPBN.NOSE, 0, 20, 14).add(
        create_joint(EOPBN.EYE_RIGHT, -3, 3, -3).add(create_joint(EOPBN.EAR_RIGHT, -4, -3, -8)),
        create_joint(EOPBN.EYE_LEFT, 3, 3, -3).add(create_joint(EOPBN.EAR_LEFT, 4, -3, -8)),
      ),
      create_group(EOpenPoseBodyGroup.SHOULDER_RIGHT_INNER).add(
        create_joint(EOPBN.SHOULDER_RIGHT, -width / 2, 0, 0).add(
          create_joint(EOPBN.ELBOW_RIGHT, 0, -25, 0).add(
            create_joint(EOPBN.WRIST_RIGHT, 0, -25, 0),
            // .add(create_hand(BEN.HAND_RIGHT))
          ),
        ),
      ),
      create_group(EOpenPoseBodyGroup.SHOULDER_LEFT_INNER).add(
        create_joint(EOPBN.SHOULDER_LEFT, width / 2, 0, 0).add(
          create_joint(EOPBN.ELBOW_LEFT, 0, -25, 0).add(
            create_joint(EOPBN.WRIST_LEFT, 0, -25, 0),
            // .add(create_hand(BEN.HAND_LEFT))
          ),
        ),
      ),
      create_group(EOpenPoseBodyGroup.HIP_RIGHT_INNER).add(
        create_joint(EOPBN.HIP_RIGHT, -width / 2 + 7, -height, 0).add(
          create_joint(EOPBN.KNEE_RIGHT, 0, -40, 0).add(
            create_joint(EOPBN.ANKLE_RIGHT, 0, -36, 0),
            // .add(create_foot(BEN.FOOT_RIGHT))
          ),
        ),
      ),
      create_group(EOpenPoseBodyGroup.HIP_LEFT_INNER).add(
        create_joint(EOPBN.HIP_LEFT, width / 2 - 7, -height, 0).add(
          create_joint(EOPBN.KNEE_LEFT, 0, -40, 0).add(
            create_joint(EOPBN.ANKLE_LEFT, 0, -36, 0),
            // .add(create_foot(BEN.FOOT_LEFT))
          ),
        ),
      ),
    ),

    // ),
  );

  return torso;
}
